import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { legacyTarget } from './registry';

// /web-integration#php → /sdks/php, /mobile-integration → /sdks?type=mobile,
// /plugin-sdk → /sdks. Keeps old links, bookmarks and search results working.
function LegacyRedirect({ kind = 'web' }) {
    const { hash } = useLocation();
    return <Redirect to={legacyTarget(kind, hash)} />;
}

export default LegacyRedirect;
